<header>
  <div class="container-width">
    <!-- Header Left -->
    <div class="header-left">
      <img
        (click)="reloadPage()"
        loading="lazy"
        class="logo"
        src="/Tridimo_logo_Web_Transparent-300dpi_2246x528.png"
        alt="logo"
      />
    </div>

    <!-- Header Right -->
    <div class="header-right">

      <c-header-nav class="header-nav ms-auto ms-md-0" role="navigation">

        <c-dropdown alignment="end">

           <button
            cDropdownToggle
            type="button"
            style="
              border: none;
              background: transparent;
              position: relative;
              display: flex;
              align-items: center;
              gap: 4px;
            "
          >Inbox</button>

          <ul cDropdownMenu style="width: auto">
             <li>
              <a (click)="navigateTo('inbox')" class="dropdown-item">
                Inbox
              </a>
            </li>
          </ul>

        </c-dropdown>

      </c-header-nav>

      <c-header-nav class="header-nav ms-auto ms-md-0" role="navigation">

        <c-dropdown alignment="end">

          <button
            cDropdownToggle
            type="button"
            style="
              border: none;
              background: transparent;
              position: relative;
              display: flex;
              align-items: center;
              gap: 4px;
            "
          >
            <!-- <img class="user-icon" [src]="this.userIconUrl"> -->

            <div
              class="user-icon"
              [ngStyle]="{ 'background-image': 'url(' + userIconUrl + ')' }"
            ></div>

            <div>{{ userName }}</div>
          </button>

          <ul cDropdownMenu style="width: auto">

            <li>
              <h6
                cDropdownHeader
                class="dropdown-header bg-body-secondary text-body-secondary fw-semibold my-2"
              >
                Account Info
              </h6>
            </li>

            <li class="dropdown-item">
              {{ userEmail }}
            </li>

            <li>
              <h6
                cDropdownHeader
                class="dropdown-header bg-body-secondary text-body-secondary fw-semibold my-2"
              >
                Apps
              </h6>
            </li>

            <li>
              <a (click)="openWebsite('intranet')" class="dropdown-item">
                Intranet
              </a>
            </li>

            <li>
              <a (click)="openWebsite('aufgaben')" class="dropdown-item">
                Aufgaben
              </a>
            </li>

            <li>
              <a (click)="openWebsite('bestaetigung')" class="dropdown-item">
                Bestätigung
              </a>
            </li>

            <li *ngIf="getUserPermission() === 'admin'">
              <a
                (click)="openWebsite('admin-management')"
                class="dropdown-item"
              >
                Admin Management
              </a>
            </li>

            <li>
              <h6
                cDropdownHeader
                class="dropdown-header bg-body-secondary text-body-secondary fw-semibold my-2"
              >
                Settings
              </h6>
            </li>

            <li>
              <a (click)="navigateTo('Einstellungen')" class="dropdown-item">
                Einstellungen
              </a>
            </li>

            <li cDropdownDivider class="dropdown-divider"></li>

            <li>
              <a (click)="logout()" class="dropdown-item">
                Logout
              </a>
            </li>

          </ul>

        </c-dropdown>

      </c-header-nav>

      <!-- Burger Button -->
      <!--
      <button
        *ngIf="smallTabView && showSidebar"
        (click)="toggleSidebarHandler()"
        class="menu-btn"
      >
        <svg
          [cIcon]="icons.cilHamburgerMenu"
          size="xl"
          title="Menü"
        ></svg>
      </button>
      -->

    </div>

  </div>
</header>